import { AxiosResponse } from "axios";
import { axiosInstanceWebsite } from "../instance";
import { decodeTokenService } from "../decodeTokenService";

interface CreateSubscriptionProps {
  membership_id: number;
  client_reference_id?: string;
}

export enum registerSellerList {
  MERCADO_PAGO = "mercadopago",
  STRIPE = "stripe",
}

export const postRegisterSeller = async (id: string, email: string) => {
  const data = {
    email: email,
  };
  return postRegisterSellerApi(id, data);
};

export const postRegisterSellerApi = async (id: string, data: any) => {
  const response: AxiosResponse = await axiosInstanceWebsite.post(
    `/payment/${id}/register-seller`,
    data
  );
  return response.data;
};

export const getPaymentMethodConfiguration = async () => {
  const response: AxiosResponse = await axiosInstanceWebsite.get(
    `/payment/provider/store`
  );
  return response.data;
};

export const getPaymentMethods = async (userId: string) => {
  const response: AxiosResponse = await axiosInstanceWebsite.get(
    `/payment/provider/store/${userId}/active`
  );
  return response.data;
};

export const getAllPaymentMethods = async () => {
  const response: AxiosResponse = await axiosInstanceWebsite.get(
    `/payment/provider`
  );
  return response.data;
};

export const updatePaymentMethodActive = async (id: string) => {
  const response: AxiosResponse = await axiosInstanceWebsite.put(
    `/payment/provider/${id}/activate`
  );
  return response.data;
};

export const updatePaymentMethodInactive = async (id: string) => {
  const response: AxiosResponse = await axiosInstanceWebsite.put(
    `/payment/provider/${id}/deactivate`
  );
  return response.data;
};

export const postCreateSubscription = async (data: CreateSubscriptionProps) => {
  const token = decodeTokenService.getToken();
  const headers = {
    "Authorization": `Bearer ${token}`,
  };
  const response: AxiosResponse = await axiosInstanceWebsite.post(
    `/payment/create-subscription-session`,
    data,
    { headers }
  );
  return response.data;
};